module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('div', {
    staticClass: "content-wrapper column centered-start",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Processo Simplificado")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Proposta Simplificada',
        active: true
      }]
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "column all-centered prop-simp-container"
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Carregando...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "column centered-start prop-simp-container"
  }, [_vm._m(1), _vm._v(" "), (!_vm.adicionarRegistro) ? _c('div', {
    staticClass: "row-flex start-centered prop-simp-navbar-container"
  }, [_c('div', {
    staticClass: "row-flex all-centered",
    class: _vm.tabSelect == 'Proposta' ? 'prop-simp-button-selected' : 'prop-simp-button',
    on: {
      "click": function($event) {
        return _vm.handleTab('Proposta')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Propostas\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered",
    class: _vm.tabSelect == 'Edital' ? 'prop-simp-button-selected' : 'prop-simp-button',
    on: {
      "click": function($event) {
        return _vm.handleTab('Edital')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Editais\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.adicionarRegistro) ? _c('div', {
    staticClass: "column centered-start prop-simp-cadastro-container"
  }, [_c('div', {
    staticClass: "column all-start log-title-container"
  }, [_c('h3', {
    staticClass: "log-title row-flex centered-start"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Adicionar novo registro de " + _vm._s(_vm.tabSelect) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prop-simp-aviso"
  }, [_vm._m(2), _vm._v(" "), (_vm.tabSelect == 'Proposta') ? _c('div', [_vm._v("\n              AVISO: as propostas adicionadas "), _c('b', [_vm._v("manualmente")]), _vm._v(" ficam "), _c('b', [_vm._v("pendentes")]), _vm._v(" de "), _c('b', [_vm._v("acertos manuais")]), _vm._v(" por "), _c('b', [_vm._v("parte do usuário")]), _vm._v(", tanto no "), _c('b', [_vm._v("cronograma")]), _vm._v(" quanto na "), _c('b', [_vm._v("análise")]), _vm._v(", a depender do seu "), _c('b', [_vm._v("status")]), _vm._v(". Para propostas já aprovadas, será habilitado apenas a "), _c('b', [_vm._v("prestação de contas")]), _vm._v(" do processo simplificado e os acertos de cronograma, caso necessário, devem ser feitos através da ferramenta de "), _c('b', [_vm._v("alteração de projetos")]), _vm._v(".\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tabSelect == 'Edital') ? _c('div', [_vm._v("\n              AVISO: para propostas de editais que já estão em fase de Análise, informamos que caso seja necessário, o acerto do cronograma deve ser feito manualmente. Para propostas já aprovadas, o cronograma, caso seja necessário, deverá ser alterado pela funcionalidade de alteração de projetos.\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered prop-simp-pesquisa-container"
  }, [(_vm.tabSelect == 'Proposta') ? _c('div', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.tabSelect == 'Edital') ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prop-simp-pesquisa"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.termoPesquisa),
      expression: "termoPesquisa"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty prop-simp-input",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar..."
    },
    domProps: {
      "value": (_vm.termoPesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisarNovoRegistro()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.termoPesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.pesquisarNovoRegistro()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Pesquisar")])], 1)]), _vm._v(" "), (_vm.loadingPesquisa) ? _c('div', {
    staticClass: "column all-centered log-title-container"
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Pesquisando...")])]) : _vm._e(), _vm._v(" "), (!_vm.loadingPesquisa) ? _c('b-container', {
    staticClass: "table-simp-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    key: _vm.tableDataKey,
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": true,
      "items": _vm.tablePesquisa.items,
      "fields": _vm.tablePesquisa.fields,
      "current-page": _vm.tablePesquisa.currentPage,
      "per-page": _vm.tablePesquisa.perPage,
      "filter": _vm.tablePesquisa.filter,
      "empty-text": "Nenhum registro encontrado",
      "sort-by": _vm.tablePesquisa.sortBy,
      "sort-desc": _vm.tablePesquisa.sortDesc
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tablePesquisa, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tablePesquisa, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tablePesquisa, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tablePesquisa, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          attrs: {
            "color": "success",
            "size": "button--size-ss",
            "title": '<h5> Adiciona registro no processo simplificado. </h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.cadastraRegistroSimplificado(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }, {
      key: "nome",
      fn: function(row) {
        return [(row.item.numero_projeto) ? _c('span', {
          staticClass: "prop-simp-span-proj"
        }, [_c('b', [_vm._v("[ " + _vm._s(row.item.numero_projeto) + " ]")])]) : _vm._e(), _vm._v(" " + _vm._s(row.value) + " "), (row.item.numero_projeto) ? _c('router-link', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              placement: 'right',
              animation: 'perspective',
              distance: '1',
              size: 'small',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
          }],
          attrs: {
            "title": '<h5>Ir para a página do Projeto</h5>',
            "to": {
              name: 'projeto',
              params: {
                numero: row.item.numero_projeto
              }
            },
            "target": "_blank"
          }
        }, [_vm._v(" "), _c('i', {
          staticClass: "fa fa-external-link"
        })]) : _vm._e()]
      }
    }], null, false, 674082884)
  }), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-end prest-total-documentos"
  }, [_c('div', [_vm._v("\n                      Total de Registros: "), _c('b', [_vm._v(_vm._s(_vm.tablePesquisa.items.length))])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.tablePesquisa.items.length,
      "per-page": _vm.tablePesquisa.perPage
    },
    model: {
      value: (_vm.tablePesquisa.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tablePesquisa, "currentPage", $$v)
      },
      expression: "tablePesquisa.currentPage"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-end prest-simp-busca-botoes"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNovoRegistro(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.tabSelect == 'Proposta' && !_vm.adicionarRegistro) ? _c('b-container', {
    staticClass: "table-simp-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "row-flex all-centered prop-simp-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table.filter),
      expression: "table.filter"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty prop-simp-input",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa propostas..."
    },
    domProps: {
      "value": (_vm.table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.table, "filter", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNovoRegistro(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Adicionar Proposta")])], 1), _vm._v(" "), _c('b-table', {
    key: _vm.tableDataKey,
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": true,
      "bordered": true,
      "items": _vm.table.items,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.table.filter,
      "empty-text": "Nenhum registro encontrado",
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "simplificado",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          attrs: {
            "color": row.value == 0 ? 'warning' : 'success',
            "size": "button--size-ss",
            "title": row.value == 0 ? '<h5> Ativa processo simplificado. </h5>' : '<h5> Desativa processo simplificado. </h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.alteraProcessoSimplificado(row.item)
            }
          }
        }, [_c('i', {
          class: row.value == 0 ? 'fa fa-warning' : 'fa fa-check',
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.value == 0 ? 'Inativo' : 'Ativo'))])]
      }
    }, {
      key: "nome_proposta",
      fn: function(row) {
        return [_c('div', {
          staticClass: "column start-centered"
        }, [_c('div', [_c('span', {
          staticClass: "prop-simp-span-id"
        }, [_vm._v("["), _c('b', [_vm._v(_vm._s(row.item.fk_proposta))]), _vm._v("] ")]), _vm._v("  " + _vm._s(row.value) + " "), (row.item.ds_codigo_projeto_erp) ? _c('span', {
          staticClass: "prop-simp-span-proj"
        }, [_c('b', [_vm._v("(" + _vm._s(row.item.ds_codigo_projeto_erp) + ")"), _c('router-link', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              placement: 'right',
              animation: 'perspective',
              distance: '1',
              size: 'small',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
          }],
          attrs: {
            "title": '<h5>Ir para a página do Projeto</h5>',
            "to": {
              name: 'projeto',
              params: {
                numero: row.item.ds_codigo_projeto_erp
              }
            },
            "target": "_blank"
          }
        }, [_vm._v(" "), _c('i', {
          staticClass: "fa fa-external-link"
        })])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "row-flex all-end prop-simp-entidade-container break"
        }, [_c('div', {
          staticClass: "row-flex"
        }, [_vm._v("\n                                " + _vm._s(row.item.nome_entidade) + "\n                              ")]), _vm._v(" "), _c('div', {
          staticClass: "row-flex gap-5"
        }, [_vm._v("\n                                [ " + _vm._s(_vm._f("cnpj")(row.item.ds_cnpj)) + " ] "), _c('b', [_c('router-link', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              placement: 'right',
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
          }],
          attrs: {
            "title": '<h5>Ir para o Cadastro da entidade</h5>',
            "to": {
              name: 'cadastro-entidade-visualiza',
              params: {
                id: row.item.id_entidade
              }
            },
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-user"
        })])], 1)])])])]
      }
    }, {
      key: "valor_fbb",
      fn: function(row) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("real")(row.value)) + "\n                        ")]
      }
    }, {
      key: "edital",
      fn: function(row) {
        return [(row.item.id_edital) ? _c('div', [_vm._v("\n                            (" + _vm._s(row.item.id_edital) + ") " + _vm._s(row.value) + "\n                          ")]) : _c('div', [_vm._v("\n                            Prospecção Direta\n                          ")])]
      }
    }], null, false, 2953825950)
  }), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-end prest-total-documentos"
  }, [_c('div', [_vm._v("\n                    Total de Registros: "), _c('b', [_vm._v(_vm._s(_vm.table.items.length))])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tabSelect == 'Edital' && !_vm.adicionarRegistro) ? _c('b-container', {
    staticClass: "table-simp-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "row-flex all-centered prop-simp-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableEdital.filter),
      expression: "tableEdital.filter"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa editais..."
    },
    domProps: {
      "value": (_vm.tableEdital.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableEdital, "filter", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNovoRegistro(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Adicionar Edital")])], 1), _vm._v(" "), _c('b-table', {
    key: _vm.tableDataKey,
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": true,
      "items": _vm.tableEdital.items,
      "fields": _vm.tableEdital.fields,
      "current-page": _vm.tableEdital.currentPage,
      "per-page": _vm.tableEdital.perPage,
      "filter": _vm.tableEdital.filter,
      "empty-text": "Nenhum registro encontrado",
      "sort-by": _vm.tableEdital.sortBy,
      "sort-desc": _vm.tableEdital.sortDesc
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tableEdital, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tableEdital, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tableEdital, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tableEdital, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "simplificado",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          attrs: {
            "color": row.value == 0 ? 'warning' : 'success',
            "size": "button--size-ss",
            "title": row.value == 0 ? '<h5> Ativa processo simplificado. </h5>' : '<h5> Desativa processo simplificado. </h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.alteraProcessoSimplificado(row.item)
            }
          }
        }, [_c('i', {
          class: row.value == 0 ? 'fa fa-warning' : 'fa fa-check',
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.value == 0 ? 'Inativo' : 'Ativo'))])]
      }
    }], null, false, 3723868672)
  }), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-end prest-total-documentos"
  }, [_c('div', [_vm._v("\n                    Total de Registros: "), _c('b', [_vm._v(_vm._s(_vm.tableEdital.items.length))])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.tableEdital.items.length,
      "per-page": _vm.tableEdital.perPage
    },
    model: {
      value: (_vm.tableEdital.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tableEdital, "currentPage", $$v)
      },
      expression: "tableEdital.currentPage"
    }
  })], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "box-body text-center"
  }, [_c('i', {
    staticClass: "fa fa-refresh sa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column all-start log-title-container"
  }, [_c('h3', {
    staticClass: "log-title row-flex centered-start"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Gerenciador de Proposta Simplificada\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "prop-simp-span"
  }, [_vm._v("Atenção: as propostas vinculadas a editais aparecerão aqui conforme "), _c('b', [_vm._v("análise")]), _vm._v(" (propostas já cadastradas no sistema), conforme "), _c('b', [_vm._v("liberação de propostas")]), _vm._v(" (novas propostas liberadas pelo usuário) e/ou conforme "), _c('b', [_vm._v(" autocredenciamento")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column all-centered prest-declaracoes-icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_vm._v("Pesquise por "), _c('b', [_vm._v("número de projeto")]), _vm._v(", "), _c('b', [_vm._v("número da proposta")]), _vm._v(" ou "), _c('b', [_vm._v("nome do projeto")]), _vm._v(" e clique em Pesquisar.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_vm._v("Pesquise por "), _c('b', [_vm._v("número do edital")]), _vm._v(" ou "), _c('b', [_vm._v("nome do edital")]), _vm._v(" e clique em Pesquisar.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "box-body text-center"
  }, [_c('i', {
    staticClass: "fa fa-refresh sa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-440390c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposta/GerenciadorPropostaSimplificada.vue
// module id = 1929
// module chunks = 1